import { DISEASE } from './disease';

export const CALL_US_BY_DISEASE = {
  [DISEASE.LUNG]: {
    name: 'Tina',
    tel: '+1 513-409-0629',
  },
  [DISEASE.HCC]: {
    name: 'Tina',
    tel: '+1 513-409-0629',
  },
  [DISEASE.BREAST_2]: {
    name: 'Youvona',
    tel: '+1 512-387-0450',
  },
  [DISEASE.OVARIAN]: {
    name: 'Youvona',
    tel: '+1 512-387-0450',
  },
  [DISEASE.UTERINE]: {
    name: 'Youvona',
    tel: '+1 512-387-0450',
  },
  [DISEASE.CRC]: {
    name: 'Heather',
    tel: '+1 201-782-6721',
  },
  [DISEASE.CRC_2]: {
    name: 'Heather',
    tel: '+1 201-782-6721',
  },
  [DISEASE.HNSCC]: {
    name: 'Heather',
    tel: '+1 201-782-6721',
  },
  [DISEASE.BRAIN]: {
    name: 'Heather',
    tel: '+1 201-782-6721',
  },
  [DISEASE.PROSTATE]: {
    name: 'Kimberly',
    tel: '+1 317-721-1075',
  },
  [DISEASE.BLADDER_2]: {
    name: 'Kimberly',
    tel: '+1 317-721-1075',
  },
  [DISEASE.RCC]: {
    name: 'Kimberly',
    tel: '+1 317-721-1075',
  },
  [DISEASE.MELANOMA_2]: {
    name: 'Kristine',
    tel: '+1 973-709-8208',
  },
  [DISEASE.GI_TRACT]: {
    name: 'Kristine',
    tel: '+1 973-709-8208',
  },
  [DISEASE.MPN]: {
    name: 'Kristine',
    tel: '+1 973-709-8208',
  },
  [DISEASE.NHL]: {
    name: 'Kristine',
    tel: '+1 973-709-8208',
  },
  [DISEASE.AML]: {
    name: 'Kristine',
    tel: '+1 973-709-8208',
  },
  [DISEASE.MM]: {
    name: 'Kristine',
    tel: '+1 973-709-8208',
  },
  [DISEASE.MDS]: {
    name: 'Kristine',
    tel: '+1 973-709-8208',
  },
  [DISEASE.CML]: {
    name: 'Kristine',
    tel: '+1 973-709-8208',
  },
  [DISEASE.SARCOMA]: {
    name: 'Youvona',
    tel: '+1 512-387-0450',
  },
};

// is supposed to use for any indication is missing in SUPPORTED_CALL_BY_DISEASE
export const DEFAULT_CALL_US = {
  name: 'Tina',
  tel: '+1 513-409-0629',
};
